import React, { useEffect } from "react";
import {
  TextInputProps,
  TextInput,
  InputLabelProps,
} from "@src/components/elements/TextInput";

type NumberInputProps = Omit<
  TextInputProps,
  "onChange" | "type" | "label" | "labelType"
> &
  InputLabelProps & {
    setValue: (newValue: number | null) => void;
  };

export const NumberInput: React.FC<NumberInputProps> = React.forwardRef<
  HTMLInputElement,
  NumberInputProps
>((props, ref) => {
  useEffect(() => {
    // stop the scroll wheel event from changing the value of the input
    function wheelHandler() {
      const elem =
        document.activeElement instanceof HTMLInputElement
          ? document.activeElement
          : null;
      if (elem?.type === "number") {
        elem.blur();
      }
    }
    document.addEventListener("wheel", wheelHandler);
    return () => {
      document.removeEventListener("wheel", wheelHandler);
    };
  }, []);

  const { setValue, value } = props;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value ? Number(event.target.value) : null);
  };

  return (
    <TextInput
      ref={ref}
      {...props}
      className={
        props.error
          ? `field-error ${props.className ?? ""}`
          : props.className ?? ""
      }
      value={value ? value.toString() : null}
      type="number"
      onChange={onChange}
    />
  );
});

NumberInput.displayName = "NumberInput";
